import { apiClient } from '../../../app/api/apiClient';
import type { DashboardSummaryDTO } from '../types/dashboard.dto';

interface FetchDashboardOptions {
  signal?: AbortSignal;
}

export async function fetchDashboardSummary(
  options?: FetchDashboardOptions
): Promise<DashboardSummaryDTO> {
  const requestOptions = options?.signal
    ? { signal: options.signal }
    : {};

  const response = await apiClient.get<DashboardSummaryDTO>(
    '/api/representative/dashboard',
    requestOptions
  );

  return response.data;
}
